// let table_heading = document.querySelectorAll(".comparison-item-top");
// let max_table_heading = 0;
// table_heading.forEach((item) => {
//   let item_height = item.offsetHeight;
//   max_table_heading =
//     item_height > max_table_heading ? item_height : max_table_heading;
// });
// // console.log("Result: " + max_table_heading);
// table_heading.forEach((item) => {
//   item.style.height = max_table_heading + "px";
//   // item.style.paddingTop = 0;
//   // item.style.paddingBottom = 0;
// });
setTimeout(() => {
  let product_items = document.querySelectorAll(".product-comparison-item");
  let length = product_items[0].querySelectorAll(".comparison-item-bottom").length;

  for (let i = 0; i < length; i++) {
    let max_height = 0;
    product_items.forEach((val) => {
      let item_height = val.querySelectorAll(".comparison-item-bottom")[i].offsetHeight;
      max_height = item_height > max_height ? item_height : max_height;
    });
    product_items.forEach((val) => {
      val.querySelectorAll(".comparison-item-bottom")[i].querySelector(".comparison-list-item").style.height = max_height + "px";
    });
  }
}, 1000);